import { motion } from "framer-motion";

export const PageHero = ({ overline, title, subtitle, children }) => (
  <section className="relative pt-36 pb-16 md:pt-44 md:pb-20 overflow-hidden" data-testid="page-hero">
    <div className="absolute -top-20 -right-20 h-72 w-72 rounded-full bg-crate-yellow/10 blur-3xl" />
    <div className="mx-auto max-w-7xl px-6 md:px-12 relative">
      <motion.span
        initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
        className="inline-block text-crate-yellow font-bold uppercase tracking-[0.25em] text-xs md:text-sm mb-5"
      >
        {overline}
      </motion.span>
      <motion.h1
        initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
        className="font-heading font-black text-white leading-[0.95] tracking-tighter text-5xl sm:text-6xl md:text-7xl max-w-4xl"
      >
        {title}
      </motion.h1>
      {subtitle && (
        <motion.p
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.25 }}
          className="mt-6 max-w-2xl text-lg text-white/60 leading-relaxed"
        >
          {subtitle}
        </motion.p>
      )}
      {children}
    </div>
  </section>
);
